export * from './HomepageHero';

import { HomepageHero } from './HomepageHero';

export default HomepageHero;